import { AttachFile, DeleteRounded } from '@mui/icons-material'
import { Badge, Box, IconButton, Tooltip, Typography } from '@mui/material'
import Table from 'common/components/Table'
import { CustomModalContext } from 'common/contexts/CustomModalContext'
import { getLocaleDateString } from 'common/libs/fechas'
import { enqueueSnackbar } from 'notistack'
import { useContext } from 'react'
import ThemeManager from 'theming/ThemeManager'
import { deleteHojaGastoLin } from '../lib/HojasGastoLinController'
import ExpenseModal from './ExpenseModal'

export const HojasGastoLinTable = ({
  id_hoja,
  showButton = true,
  handleChangeState,
  fechaInicio,
  fechaFin,
  disableAll,
  lineas,
  loading,
}) => {
  const Theme = new ThemeManager()
  const { handleModal } = useContext(CustomModalContext)

  const handleDeleteClick = async ({ id_hoja, id_lin }) => {
    try {
      await deleteHojaGastoLin({ id_hoja, id_lin })
      enqueueSnackbar('Línea borrada correctamente', { variant: 'success' })
      handleChangeState()
    } catch (error) {
      enqueueSnackbar('No se ha podido borrar la línea')
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: '10px',
        width: '100%',
      }}
    >
      <Table
        page={1}
        count={lineas?.length ?? 0}
        dataSource={lineas}
        header_style={{
          backgroundColor: Theme.pallete?.primary?.main,
          color: Theme.pallete.primary.contrastText,
        }}
        header_cell_style={{ padding: '10px' }}
        table_style={{ width: '100%', borderCollapse: 'collapse' }}
        container_style={{ borderRadius: '5px', marginBottom: '5px', marginTop: '10px' }}
        generic_cell_style={{
          textAlign: 'left',
          padding: '15px 10px',
        }}
        loading={loading}
        emptyText={'No hay gastos para esta hoja'}
        stripped={true}
        sx={{ textAlign: 'left' }}
        onRowClick={(item) =>
          handleModal({
            closable: true,
            content: (
              <ExpenseModal
                id_hoja={id_hoja}
                updateState={handleChangeState}
                lineInfo={item.row}
                fechaInicio={fechaInicio}
                fechaFin={fechaFin}
              />
            ),
          })
        }
        fields={[
          {
            field: 'fecha',
            title: 'FECHA',
            customGetter: (item) => (item?.fecha ? getLocaleDateString(item?.fecha) : ''),
          },
          {
            field: 'd_concepto',
            title: 'CONCEPTO',
            cellWidth: '2fr',
          },
          {
            field: 'descripcion',
            title: 'DESCRIPCIÓN',
            cellWidth: '2fr',
          },
          {
            field: 'observaciones',
            title: 'OBSERVACIONES',
            cellWidth: '3fr',
          },
          {
            field: 'cantidad',
            title: (
              <Typography align="end" fontWeight="600">
                CANTIDAD
              </Typography>
            ),
            customGetter: (item) => (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>{item.cantidad}</Box>
            ),
          },
          {
            field: 'precio',
            title: (
              <Typography align="end" fontWeight="600">
                PRECIO
              </Typography>
            ),
            customGetter: (item) => (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                {item.precio ? item.precio.toFixed(2) : item.precio}
              </Box>
            ),
          },
          {
            field: 'importe_interno',
            title: (
              <Typography align="end" fontWeight="600">
                IMPORTE
              </Typography>
            ),
            customGetter: (item) => (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                {item.precio ? item.precio.toFixed(2) : item.precio}
              </Box>
            ),
          },
          {
            field: 'adjuntos',
            title: '',
            forceWidth: true,
            cellWidth: '100px',
            customGetter: (item) => (
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                {item.documentos.length > 0 ? (
                  <Badge badgeContent={item.documentos.length} color="primary">
                    <Tooltip
                      title={
                        item.documentos.length > 0 ? (
                          <Box>
                            <Typography variant="body1">Documentos adjuntos</Typography>
                            {item.documentos.map((doc, index) => (
                              <Typography key={doc.id || index} variant="body1" align="end">
                                {doc.descripcion}
                              </Typography>
                            ))}
                          </Box>
                        ) : (
                          'No hay ficheros adjuntos'
                        )
                      }
                    >
                      <IconButton>
                        <AttachFile />
                      </IconButton>
                    </Tooltip>
                  </Badge>
                ) : (
                  <></>
                )}
              </Box>
            ),
          },
          {
            field: 'FUNCIONES',
            title: '',
            forceWidth: true,
            cellWidth: '100px',
            customGetter: (item) => (
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                {showButton && !disableAll ? (
                  <IconButton
                    color="error"
                    onClick={() =>
                      handleDeleteClick({ id_hoja: item.id_hoja, id_lin: item.id_lin })
                    }
                  >
                    <DeleteRounded />
                  </IconButton>
                ) : null}
              </Box>
            ),
          },
        ]}
      />
    </Box>
  )
}
